import { render, staticRenderFns } from "./help.vue?vue&type=template&id=486ecc10&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=486ecc10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486ecc10",
  null
  
)

export default component.exports